import React, { useState } from "react";
import { KeyRound } from "lucide-react";
import { api, getApiError } from "@/lib/api";

export default function PasswordPanel() {
  const [form, setForm] = useState({ current_password: "", new_password: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    try {
      await api.post("/admin/password", form);
      setForm({ current_password: "", new_password: "" });
      setMessage("Password updated.");
    } catch (requestError) {
      setError(getApiError(requestError));
    }
  };
  return (
    <section className="admin-panel" data-testid="admin-password-panel">
      <h2>Access key</h2>
      <p className="admin-panel-intro">Change the private editor password whenever you are ready.</p>
      <form onSubmit={submit}>
        <div className="form-field"><label className="form-label" htmlFor="current-admin-password">Current password</label><input className="text-input" id="current-admin-password" type="password" value={form.current_password} onChange={(event) => setForm((current) => ({ ...current, current_password: event.target.value }))} required data-testid="admin-current-password-input" /></div>
        <div className="form-field"><label className="form-label" htmlFor="new-admin-password">New password</label><input className="text-input" id="new-admin-password" type="password" minLength="8" value={form.new_password} onChange={(event) => setForm((current) => ({ ...current, new_password: event.target.value }))} required data-testid="admin-new-password-input" /></div>
        {error && <p className="form-error" data-testid="admin-password-error">{error}</p>}
        {message && <p className="form-success" data-testid="admin-password-success">{message}</p>}
        <button className="admin-button" type="submit" data-testid="admin-change-password-btn"><KeyRound size={14} /> Change password</button>
      </form>
    </section>
  );
}
